import { defineStore } from 'pinia'

interface State {
  loading: {
    active: boolean
    value: number | null
    messages: string
  }
  title: string
  appBackground: string | null
}

export const useAppStore = defineStore('app', {
  state: (): State => ({
    loading: {
      active: true,
      value: null,
      messages: '',
    },
    title: 'questions.creator',
    appBackground: '',
  }),

  getters: {
    documentTitle(): string {
      return this.t(this.title)
    },
    isLoading(): boolean {
      return this.loading.active
    },
    background(): string | null {
      return this.appBackground
    },
    loadingMessages(): string {
      return this.loading.messages
    },
    getProgress(): number | null {
      return this.loading.value
    },
  },

  actions: {
    setTitle(payload: string) {
      document.title = this.t(payload)
      this.title = this.t(payload)
    },
    setBackground(className: string | null) {
      this.appBackground = className
    },
    setLoadingActive(isActive: boolean) {
      this.loading.active = isActive
      if (!isActive) {
        this.loading.value = null
        this.loading.messages = ''
      }
    },
    setLoadingValue(value: number | null) {
      this.loading.value = value
    },
    setLoadingMessages(messages: string) {
      this.loading.messages = messages
    },
  },
})
